import React, { useContext } from "react";
import Context from "../../../Context";
function HeaderUserButton() {
  const cx = useContext(Context);
  let show = cx.user.show || {};
  const { passwordchange } = cx.user.info.profile;
  return (
    <div className="topbar-item">
      <div
        onClick={cx.userMenuToggle}
        className="btn btn-icon btn-icon-mobile w-auto btn-clean d-flex align-items-center btn-lg px-2"
      >
        <span className="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">
          {show.name}
        </span>
        <span className="symbol symbol-lg-35 symbol-25 symbol-light ">
          {show.picture ? (
            <img alt="userpic" src={show.picture} />
          ) : (
            <span className="symbol-label font-size-h5 font-weight-bold bg-primary-o-20">
              {show.literal}
            </span>
          )}
          {passwordchange && <i className="symbol-badge bg-warning"></i>}
        </span>
      </div>
    </div>
  );
}
export default HeaderUserButton;
